import { Menu, type MenuClickTriggerProps, type MenuRootProps, type MenuVariantProps } from "@overmap-ai/blocks"
import { issueTypeStatusSortFn } from "@overmap-ai/common"
import { useSort } from "@overmap-ai/hooks"
import { memo, type ReactElement } from "react"

import {
	IssueTypeStatusMultiSelectGroup,
	type IssueTypeStatusMultiSelectGroupProps,
} from "../MenuMultiSelectGroups/IssueTypeStatusMultiSelectGroup"

interface IssueTypeStatusMultiSelectProps
	extends
		MenuRootProps,
		IssueTypeStatusMultiSelectGroupProps,
		MenuVariantProps,
		Omit<MenuClickTriggerProps, "children" | "ref"> {
	children: ReactElement
}

export const IssueTypeStatusMultiSelect = memo((props: IssueTypeStatusMultiSelectProps) => {
	const { children, values, issueTypeStatuses, onValuesChange, disabled, variant, size, accentColor, ...rest } = props

	const sortedIssueTypeStatuses = useSort(issueTypeStatuses, issueTypeStatusSortFn)

	return (
		<Menu.Root {...rest}>
			<Menu.ClickTrigger disabled={disabled}>{children}</Menu.ClickTrigger>
			<Menu.Content variant={variant} size={size} accentColor={accentColor}>
				<Menu.Scroll>
					<IssueTypeStatusMultiSelectGroup
						values={values}
						issueTypeStatuses={sortedIssueTypeStatuses}
						onValuesChange={onValuesChange}
					/>
				</Menu.Scroll>
			</Menu.Content>
		</Menu.Root>
	)
})
IssueTypeStatusMultiSelect.displayName = "IssueTypeStatusMultiSelect"
